/**
 * Gets the value of a cookie.
 * @param {string} name The name of the cookie.
 * @returns The value of the cookie if it exists, otherwise `undefined`.
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return undefined;
}

/**
 * Augments the cookie name with the current environment if not in production.
 * This makes it easier to keep them separated from production cookies which have their domain set to an ancestor of the test cookies domain.
 *
 * @param {string} cookieName The name of the cookie.
 * @returns The augmented cookie name.
 */
export function augmentCookieName(cookieName) {
    const env = process.env.REACT_APP_NODE_ENV;
    return env !== "production" ? `${env}_${cookieName}` : cookieName;
}
